module.exports = {"211103001":"振兴街道","211103002":"兴隆街道","211103003":"渤海街道","211103004":"新工街道","211103005":"于楼街道","211103006":"友谊街道","211103007":"曙光街道","211103008":"欢喜街道","211103009":"平安街道","211103010":"新生街道","211103012":"高升街道","211103013":"沈采街道","211103014":"锦采街道","211103015":"茨采街道","211103016":"创新街道","211103017":"兴盛街道","211103018":"兴海街道","211103019":"惠宾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211103.json
// module id = 531
// module chunks = 0